<form [formGroup]="datePicker" (ngSubmit)="viewReport(datePicker)" class="d-flex align-items-end flex-wrap" style="gap: 10px;">
    <div>
        <label class="dp-label">Start Date</label>
        <app-date-picker formControlName="start"></app-date-picker>
        <mat-error *ngIf="!datePicker.controls['start'].value">
            required
        </mat-error>
    </div>
    <div>
        <label class="dp-label">End Date</label>
        <app-date-picker formControlName="end" [min]="minDate"></app-date-picker>
        <mat-error *ngIf="!datePicker.controls['end'].value">
            required
        </mat-error>
    </div>
    <button type="submit" class="btn btn-primary">View</button>
</form>
